<div class="fixed top-0 left-0 right-0 bottom-0 bg-(--loading-overlay-color) flex flex-col z-[900]">
  <div
    class="bg-(--header-background-color) mb-1 text-[#545454] h-[85px] md:px-2 flex flex-row justify-between items-center">
    <span class="text-base font-semibold"> {{ projectDomain.currentProject()?.name }}</span>
    <a class="" routerLink="..">
      <mat-icon class="text-[#545454]! opacity-20">close</mat-icon>
    </a>
  </div>
  <div class="bg-white flex flex-col grow p-10 space-y-3 text-[#545454] overflow-auto">
    <span class="font-semibold text-lg">My Reports</span>
    <span>Please select the reports you would like to add to the participant</span>
    <div class="grow grid grid-cols-[repeat(auto-fill,150px)] gap-3">
      @for (r of clientReports(); track $index) {
      <div class="flex flex-col relative cursor-pointer" (click)="selectItem(r)">
        <div class="text-white bg-black h-[55px] p-1 truncate text-sm">{{ r.name }}</div>
        <img src="assets/images/reports/{{ r.id }}.png" class="w-full"
          appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async" alt="{{ r.name }}" />
        <span [class.invisible]="!isSelected(r)"
          class="material-symbols-outlined absolute text-black -top-[10px] -right-[10px] z-3 bg-white rounded-full">
          check_circle
        </span>
        <span [class.invisible]="!(isSelected(r) || isDisabled(r))"
          class="absolute -inset-px bg-white opacity-50"></span>
      </div>
      } @for (p of clientPackages(); track $index) {
      <div class="flex flex-col relative cursor-pointer" (click)="selectItem(p)">
        <div class="text-white bg-black h-[55px] p-1 truncate text-sm">{{ p.name + " " + isSelected(p) }}</div>
        <img src="assets/images/reports/Package.png" class="w-full" appImageFallback="assets/images/reports/Custom.png"
          loading="lazy" decoding="async" alt="{{ p.name }}" />
        <span [class.invisible]="!isSelected(p)"
          class="material-symbols-outlined absolute text-black -top-[10px] -right-[10px] z-3 bg-white rounded-full">
          check_circle
        </span>
        <span [class.invisible]="!(isSelected(p) || isDisabled(p))"
          class="absolute -inset-px bg-white opacity-50"></span>

      </div>
      }
    </div>
  </div>
  <div class="p-3 flex flex-col gap-3 w-full">
    <span class="text-white text-md">Selected Reports</span>
    <div class="flex items-center gap-3">
      <div class="grow grid grid-cols-[repeat(auto-fill,300px)] gap-3">
        @for (i of selectedItems(); track $index){
        <div
          class="bg-(--header-background-color) flex space-around items-center text-[#545454] p-[10px] gap-x-[10px] max-w-[500px] cursor-pointer"
          (click)="selectItem(i)">
          <img src="assets/images/reports/{{ getItemImageUrl(i) }}.png" class="max-w-[34px]"
            appImageFallback="assets/images/reports/Custom.png" loading="lazy" decoding="async" alt="{{ i.name }}" />
          <span class="truncate">{{ i.name }}</span>
        </div>
        }
      </div>
      <button matButton="filled" (click)="backToProjectDetail()">
        Continue
      </button>
    </div>
  </div>
  @if (isSubmitting()) {
  <div class="absolute inset-0 bg-black/20 flex items-center justify-center z-[950] pointer-events-none">
    <mat-icon class="text-white text-4xl">hourglass_top</mat-icon>
  </div>
  }
</div>